var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 534.2 15.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M305.8,15.4H222.5L221.1,0h82.4C304.4,5.1,305.2,10.2,305.8,15.4Z",
    fill: "#007DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.2,15.4H295.5c-.7-5.1-1.4-10.2-2-15.4H384a25.35,25.35,0,0,0,.4,2.9C384.9,7.1,385.4,11.6,384.2,15.4Z",
    fill: "#008EDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,14.4c-.1.3-.3.7-.4,1h-88c-.7-5.1-1.4-10.2-2-15.4h90.5c.1.5.1,1,.2,1.5C142.6,5.8,143.1,10.5,141.7,14.4Z",
    fill: "#88C400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5,0c-.3,3.1-.6,6.1-.8,8.9h0a33.93,33.93,0,0,1-1,6.5H168.3a2.77,2.77,0,0,0-.1-.9c-.3-4.8-.5-9.7-.5-14.5Z",
    fill: "#652F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,15.4H118.8a5,5,0,0,1-.8-.7,6.41,6.41,0,0,1-.8-3c-.4-3.9-.7-7.8-1.1-11.7h82.5C199.2,5.3,199.7,11,200.1,15.4Z",
    fill: "#440099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,15.4H0V0H73.2C74.3,5.4,75.4,11.1,76,15.4Z",
    fill: "#A3D300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,15.4H326.2c-.5-5.1-.9-10.2-1.4-15.4h81.3C407.2,4.9,408.3,10.6,409.1,15.4Z",
    fill: "#F68D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2,15.4H372.5c-.7-5.1-1.3-10.2-1.9-15.4h90.5l.7,5.7A39.65,39.65,0,0,1,462.2,15.4Z",
    fill: "#FFAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.3,13.2h0c0,.7-.1,1.5-.1,2.2H433.8c-.3-5.1-.3-10.2-.2-15.4h58.9Q491.75,6.9,491.3,13.2Z",
    fill: "#00AD50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.2,0V15.4H479.8c-.5-5.1-.9-10.2-1.4-15.4Z",
    fill: "#0EC54F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdm);
export default __webpack_public_path__ + "static/media/adm.f245402d195456f699d3c205cb1a389e.svg";
export { ForwardRef as ReactComponent };